<app-standard-bottom-sheet [isOpen]="isOpen"
                           [preventOverlayClose]="true"
                           (overlayClick)="close()"
                           [isFullScreen]="true"
                           testId="complete-bottom-sheet">
  <app-section-header title="Photo Required"
                      subtitle="Add a photo to complete this item."
                      align="center"
                      testId="complete-bottom-sheet-header" />
    <form [formGroup]="form"
        class="complete-form"
        data-testid="bq9-complete-form">
        <app-form-field [label]="'Photos (Max ' + maxPhotos + ')'"
                        [required]="true"
                        [control]="form.controls.photos"
                        [errorMessages]="{ required: 'A photo is required.' }">
            <app-photo-capture inputId="complete"
                                [images]="allImages()"
                                [invalid]="isInvalid('photos')"
                                [disabled]="imageCompressionPipelineService.isCompressingImages()"
                                [loading]="imageCompressionPipelineService.isLoadingImages()"
                                [optimizing]="imageCompressionPipelineService.isCompressingImages()"
                                [processingCount]="imageCompressionPipelineService.numberOfImagesBeingProcessed()"
                                (filesSelected)="onPhotosSelected($event)"
                                (imageClicked)="openImagesModal($event)"
                                testId="complete-bottom-sheet-photo" />
        </app-form-field>
    </form>
    
    <app-vertical-button-group [buttons]="footerButtons"
                                 class="complete-footer-buttons"
                                 [class.has-photos]="allImages().length > 2"
                                 testId="complete-bottom-sheet-footer" />
</app-standard-bottom-sheet>